import { render, staticRenderFns } from "./AddScan.vue?vue&type=template&id=4833c198&scoped=true"
import script from "./AddScan.vue?vue&type=script&lang=js"
export * from "./AddScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4833c198",
  null
  
)

export default component.exports